<template>
	<div class="panel_shouyin">
		<div class="titleLine">
			<el-row>
				<!-- <el-col :span="5">
					类型：
					<el-select v-model="type" @change="changeType" placeholder="请选择" size="mini" style="width:120px;">
						<el-option v-for="item in [
							{label:'全部',value:0},{label:'充值',value:1},{label:'消费',value:2},{label:'退货',value:3},{label:'换货',value:4},{label:'其他',value:5},{label:'充值退款',value:6},
						]" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
					</el-select>
				</el-col>
				<el-col :span="10">
					日期：
					<el-date-picker
						style="width:320px;"
						v-model="timeRange"
						@change="changeTimeRange"
						type="datetimerange"
						start-placeholder="开始时间"
						end-placeholder="结束时间"
						size="mini">
					</el-date-picker>
				</el-col> -->
				<el-col :span="3" :offset="21">
					<el-button @click="add" size="mini">绑定礼品卡</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="listLine">
			<el-table :data="tableData" style="width: 100%">
				<el-table-column label="礼品卡名称" width="170">
					<template slot-scope="scope">
						<div>{{scope.row.card_name}}</div>
					</template>
				</el-table-column>
				<el-table-column label="类型">
					<template slot-scope="scope">
						{{scope.row.card_type&&scope.row.card_type.title}}
					</template>
				</el-table-column>
				<el-table-column label="卡号" width="180">
					<template slot-scope="scope">
						{{scope.row.card_number}}
					</template>
				</el-table-column>
				<el-table-column label="面额" width="200">
					<template slot-scope="scope">
						{{scope.row.price}}
					</template>
				</el-table-column>
				<el-table-column label="剩余金额" width="200">
					<template slot-scope="scope">
						{{scope.row.surplus_money}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="100">
					<template slot-scope="scope">
						<el-button type="text" @click="see(scope.row)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pageLine">
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
		<div v-if="giftCardAdd_state">
			<giftCardAdd @submit="submit_giftCardAdd"></giftCardAdd>
		</div>
		<div v-if="giftCardSee_state">
			<giftCardSee :curItem="curRow" @submit="submit_giftCardSee"></giftCardSee>
		</div>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	import giftCardAdd from "../drawer/giftCardAdd.vue"
	import giftCardSee from "../drawer/giftCardSee.vue"
	export default {
		components:{page,giftCardAdd,giftCardSee},
		data(){
			return{
				// type:0,
				// timeRange:'',
				tableData:[],
				page:{
					page:1,
					pageSize:1000,
					total:0
				},
				// 添加
				giftCardAdd_state:false,
				// 查看
				giftCardSee_state:false,
				curRow:{},
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		watch:{
			userInfo(){
				this.page.page=1;
				this.getTableData()
			}
		},
		mounted(){
			// let params = {
			// 	"pageIndex": 1,
			// 	"pageSize": 10,
			// 	"template_id": "",
			// 	"keyword": "",
			// 	"sale_state": "",
			// 	"bind_state": "",
			// }
			// this.$http.post(process.env.VUE_APP_Url_member+'/api/GiftCard/list', params)
			
			this.getTableData();
		},
		methods: {
			add(){
				this.giftCardAdd_state=true
			},
			submit_giftCardAdd(obj){
				this.giftCardAdd_state=false;
				if(obj.type==='success'){
					this.getTableData()
				}
			},
			see(row){
				this.curRow=row
				this.giftCardSee_state=true
			},
			submit_giftCardSee(obj){
				this.giftCardSee_state=false;
				if(obj.type==='success'){
					this.getTableData()
				}
			},
			// // 改变类型
			// changeType(){
			// 	this.page.page=1;
			// 	this.getTableData();
			// },
			// // 改变时间
			// changeTimeRange(){
			// 	this.page.page=1;
			// 	this.getTableData();
			// },
			// 分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			// 获取列表
			getTableData() {
				let params = {
					memberId:this.userInfo._id,
					"page_index": this.page.page,
					"page_size": this.page.pageSize,
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_Url_member+'/api/GiftCard/listByMember', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data;
						this.page.total = res.data.length;
					}
				})
				
				// let startTime='';
				// let endTime='';
				// if(this.timeRange&&this.timeRange.length==2){
				// 	startTime=(''+new Date(this.timeRange[0]).getTime()).substr(0,10);
				// 	endTime=(''+new Date(this.timeRange[1]).getTime()).substr(0,10);
				// }
				// let params = {
				// 	keyword:'', 
				// 	type:'1',
				// 	consume_type:this.type,    // 消费类型 0:全部、1:充值、2:消费、3:退货、4:换货、5:其他
				// 	start_time:startTime,
				// 	end_time:endTime,
				// 	"member_id": this.userInfo._id,
				// 	"page_index": this.page.page,
				// 	"page_size": this.page.pageSize,
				// }
				// let loading = this.$loading()
				// this.$http.post(process.env.VUE_APP_Url_member+'/api/GiftCard/listByMember', params).then(res => {
				// 	loading.close()
				// 	if (res.code == 0) {
				// 		this.tableData = res.data.data;
				// 		this.page.total = res.data.count;
				// 	}
				// })
			},
		},
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;background-color: #fff;padding:52px 0 0;box-sizing: border-box;position: relative;
	.titleLine{
		width:100%;
		background-color: #fff;
		padding:12px 12px 12px;
		box-sizing: border-box;
		position: absolute;
		top:0;
		font-size: 14px;
		color:$fontColor;
	}
	.listLine{
		height: 100%;padding:0 0px 60px 0px;box-sizing: border-box;
		.linkText{
			color:$mainColor;
		}
	}
	.pageLine{
		position: absolute;bottom:0;z-index: 1;width:100%;padding:10px;background-color: #fff;box-sizing: border-box;
	}
}
</style>
